import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import Card, {
	CardActions,
	CardBody,
	CardFooter,
	CardFooterRight,
	CardHeader,
	CardLabel,
	CardSubTitle,
	CardTabItem,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Checks from '../../../components/bootstrap/forms/Checks';
import Modal, { ModalHeader, ModalTitle, ModalBody } from '../../../components/bootstrap/Modal';
import Icon from '../../../components/icon/Icon';
import SignatureCanvas from 'react-signature-canvas';
import Spinner from '../../../components/bootstrap/Spinner';
import StatusPopup from '../../../components/PlanningCalendar/StatusPopup';
import AuthContext from '../../../contexts/authContext';
import CreatePaimentFromDevisPopup from './CreatePaimentFromDevisPopup';
import { MailMenu } from '../../../gestioneerMenu';
import { useNavigate } from 'react-router-dom';
import ClientMontantContext from '../../../contexts/clientMontantContext';
import SignatureInput from './SignatureInput';
import Button from '../../../components/bootstrap/Button';

import ErrorPopup from '../../../components/extras/ErrorPopup';
import { postAPI, putAPI } from '../../../apis/backend/apiNode';
import { acceptPublicDevis, getPaymentLink } from '../../../apis/backend/apiPublic';
import moment from 'moment';

function buildPaymentOrderEmailHtml({
	devis,
	selectedAmountEur,
	paymentLink,
	expirationDate,
}) {
	const company = devis?.companyId || {};
	const clientName = devis?.clientId?.nom || "";
	const companyName = company?.name || "";
	const companyPhone = company?.phone || "";
	const companyEmail = company?.email || "";
	const companyLogo = company?.logo
		? `https://planniflow.gestioneer.fr/coreService/${company.logo}`
		: "";

	const address = company?.address || {};
	const addressText = [address?.street, address?.zip, address?.city].filter(Boolean).join(" ");

	const expDate = expirationDate ? moment(expirationDate) : null;
	const expDateStr = expDate?.isValid() ? expDate.format("DD/MM/YYYY") : "";
	const expTimeStr = expDate?.isValid() ? expDate.format("HH:mm:ss") : "";

	const amountStr =
		typeof selectedAmountEur === "number"
			? selectedAmountEur.toFixed(2)
			: Number(selectedAmountEur || 0).toFixed(2);

	const safePaymentLink = paymentLink || "#";
	const devisRef = devis?.reference || "";

	return `
<div style="background-color:#f9f9f9; font-family: Arial, sans-serif; line-height: 1.6; padding: 10px 0;">
  <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
    <tr>
      <td align="center">
        <table width="600" border="0" cellpadding="0" cellspacing="0" role="presentation"
          style="max-width:600px; width:100%; background-color:#ffffff; border-radius:8px;
          box-shadow:0 4px 6px rgba(0,0,0,0.1); margin-top:0;">
          
          <!-- Header -->
          <tr>
            <td style="padding:10px; background-color:#f3f4f6; border-top-left-radius:8px; border-top-right-radius:8px;">
              <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
                <tr>
                  <td align="left" valign="middle" style="width:50%;">
                    ${companyLogo
			? `<img src="${companyLogo}" alt="Logo de l'entreprise" style="display:block; border:0;" width="200" />`
			: `<div style="font-weight:700; color:#111827;">${companyName}</div>`
		}
                  </td>
                  <td align="right" valign="middle" style="width:50%; font-size:12px; color:#374151;">
                    <strong style="font-size:14px; color:#1f2937;">${companyName}</strong><br/>
                    ${companyPhone ? `${companyPhone}<br/>` : ""}
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Title -->
          <tr>
            <td style="padding:20px 10px 25px 10px; color:#333333;">
              <table width="100%" cellpadding="0" cellspacing="0" role="presentation">
                <tr>
                  <td align="left" valign="middle" style="width:60%;">
                    <h3 style="font-size:22px; color:#1f2937; margin:0; font-weight:bold;">
                      Ordre de Paiement
                    </h3>
                  </td>
                  <td align="right" valign="top" style="width:40%; font-size:13px; color:#6b7280;">
                    <p style="margin:0;">Réf : ${devisRef}</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Body -->
          <tr>
            <td style="padding:0 20px 20px; color:#333333;">
              <p style="margin-bottom:15px;">
                Bonjour ${clientName},<br/><br/>

                Cet e-mail comporte un ordre de paiement d'un montant de <strong>${amountStr} €</strong>
                ${expDateStr && expTimeStr
			? ` valable jusqu'au <strong>${expDateStr}</strong> à <strong>${expTimeStr}</strong> (heure normale d’Europe centrale).`
			: `.`
		}
                Pour confirmer le paiement, veuillez cliquer sur le lien suivant :
              </p>

              <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="margin:20px 0;">
                <tr>
                  <td align="center" style="padding:10px; background-color:#f9fafb;">
                    <a href="${safePaymentLink}" target="_blank"
                      style="font-size:16px; color:#ffffff; background-color:#f7951f;
                      padding:12px 28px; text-decoration:none; border-radius:6px;
                      font-weight:bold; display:inline-block;">
                      Lien de paiement
                    </a>
                  </td>
                </tr>
              </table>

              <p style="margin:0;">
                En cas de problème, ou si ce message ne s'affiche pas correctement, merci de contacter
                ${companyEmail ? `<strong>${companyEmail}</strong>` : `votre fournisseur`}.
                <br/><br/>
                Cordialement,
              </p>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="padding:10px; background-color:#f3f4f6; color:#1f2937; font-size:14px;
              border-bottom-left-radius:8px; border-bottom-right-radius:8px;">
              <table width="100%" role="presentation" style="line-height:1.5;">
                <tr>
                  <td valign="top" align="center">
                    <p style="font-size:16px; font-weight:800; color:#6b7280; margin:0 0 10px;">
                      ${companyName}
                    </p>

                    <p style="margin:0; font-size:12px; color:#6b7280;">
                      <img src="https://admin.store2000.fr/wp-content/uploads/2024/02/Phone.png"
                        width="15" height="15" style="vertical-align:middle; margin-right:5px;" />
                      <strong>Tél:</strong> ${companyPhone || "-"}
                    </p>

                    <p style="margin:5px 0 0; font-size:12px; color:#6b7280;">
                      <img src="https://admin.store2000.fr/wp-content/uploads/2024/02/Letter.png"
                        width="15" height="15" style="vertical-align:middle; margin-right:5px;" />
                      <strong>Email:</strong> ${companyEmail || "-"}
                    </p>

                  
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</div>
`;
}

export default function SignaturePopup({ setOpenSignature, devis, token, loadData, setDevis }) {
	const { userData } = useContext(AuthContext);
	const navigate = useNavigate();
	const sigCanvas = useRef({});
	const [sigPad, setSigPad] = useState({});
	const [disabledBtn, setDisabledBtn] = useState(true);
	const [spinner, setSpinner] = useState(false);
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);
	const [paiement, setPaiement] = useState(false);
	const [attachementSignature, setattachementSignature] = useState([]);
	const { clientMontant, setClientMontant } = useContext(ClientMontantContext);
	const [inputValue, setInputValue] = useState('Bon pour accord');
	const [obligation, setObligation] = useState(false);

	const base64ToFile = (base64, filename) => {
		const byteString = atob(base64);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const uint8Array = new Uint8Array(arrayBuffer);

		for (let i = 0; i < byteString.length; i++) {
			uint8Array[i] = byteString.charCodeAt(i);
		}

		return new File([arrayBuffer], filename, { type: 'image/png' });
	};

	const handleConfirm = () => {
		if (sigPad?.isEmpty()) {
			setObligation('remplir votre signature');
		} else {
			const data = sigPad?.getTrimmedCanvas().toDataURL('image/png').split(',')[1];
			confirmAvecSignature(data);
		}
	};
	const handleConfirmCanvas = () => {
		const data = sigCanvas?.current?.toDataURL('image/png').split(',')[1];
		confirmAvecSignature(data);
	};

	const confirmAvecSignature = async (data) => {
		try {
			setSpinner(true);
			const file = base64ToFile(data, 'signature.png');

			const formData = new FormData();
			formData.append('attachments', file);

			// const response = await postAPI(`attachment`, formData, `/Devis/${devis._id}`);
			const res = await acceptPublicDevis(devis._id, token, formData);
			// setPaiement(true);
			handleCancel()
			loadData();
		} catch (error) {
			console.error('Erreur lors de la confirmation avec signature :', error);
			// Optionally show an error toast or message
			// toast.error("Une erreur est survenue...");
		} finally {
			setSpinner(false);
			setError(error);
		}
	};

	const handleOnClick = useCallback(
		() => navigate(`/${MailMenu?.paiement?.path}/sale.order/${devis.id}/${token}`),
		[navigate],
	);

	const CreatePaiementData = async (amount) => {
		// var amount = (30 / 100) * devis?.amount_total;
		// handleOnClick();
		try {
			setError(false);
			const selected = Math.round(Number(amount)) * 100

			const resp = await fetch("/coreService/api/systempay/create-payment", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					amount: selected,   // euros in UI -> backend converts to cents
					currency: "EUR",
					orderId: devis?.reference,
					"channelOptions": {
						"channelType": "URL",

					}
				}),
			});
			const data = await resp.json();
			if (!resp.ok) throw new Error(data?.message || "CreatePayment failed");
			console.log("data******", data)
			const body = buildPaymentOrderEmailHtml({
				devis,
				selectedAmountEur: Math.round(Number(amount)),               // ex: 559.90
				expirationDate: data?.answer?.expirationDate,
				paymentLink: data?.answer?.paymentURL, // change to your real link
			});
			const send = await getPaymentLink({
				company_id: devis?.companyId,
				to_email: devis?.clientId?.emails[0],
				subject: devis?.companyId?.name + " | Ordre de paiement",
				body,
				sourceId: devis?._id
			}, "/public")
			const emailTo = devis?.clientId?.emails?.[0] || "";

			setSuccess(`Lien de paiement envoyé à ${emailTo}`);
		} catch (e) {
			setError(e?.message || String(e));
		} finally {
			setPaiement(false); // close popup in all cases
		}
	};
	const handleCancel = () => {
		setSuccess("Merci d'avoir accepté et signé le devis.");

	};

	const handleClearSignature = () => {
		sigPad?.clear();
		setDisabledBtn(true);
	};
	const deleteImage = (key) => {
		const updatedImages = attachementSignature.filter((item, index) => index != key);
		setattachementSignature(updatedImages);
	};
	return (
		<>
			<Modal setIsOpen={() => { }} isOpen={true} size='md' isScrollable classNameMd='nv-1'>
				<ModalHeader className='px-4' setIsOpen={setOpenSignature}>
					<ModalTitle id='project-edit'>
						<Icon icon={'Verified'} size={'2x'} className='me-2'></Icon>
						Accepter votre devis
					</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<CardBody>
						<div className='row g-4 mb-3'>
							<span className='fw-bold'>Article – Modalités de paiement</span>
							En signant ce devis le client accepte que le règlement de la prestation
							s’effectue selon les modalités suivantes :
							<ul className='m-4'>
								<li>
									30 % du montant total à la signature du devis, correspondant à
									l’acompte d’acceptation
								</li>
								<li>
									70 % du solde au comptant le jour de la pose / intervention,
									avant le départ des techniciens.
								</li>
							</ul>
							Aucun travail, livraison ou pose ne pourra être réalisé sans le paiement
							de l’acompte. Le solde est dû immédiatement à la fin de l’intervention,
							par virement instantané ou carte bancaire.
							<span className='fw-bold'>L441-10 du Code de commerce.</span>
						</div>
					</CardBody>

					<Card hasTab shadow={'md'} className='p-2'>
						<CardTabItem id='tab' title='Dessiner'>
							<CardBody>
								<div>
									<SignatureCanvas
										penColor='black'
										canvasProps={{ className: 'signature' }}
										ref={(ref) => {
											setSigPad(ref);
										}}
										onBegin={() => {
											setDisabledBtn(false);
										}}
									/>
								</div>
							</CardBody>
							<CardFooter>
								<CardFooterRight>
									<Button
										color='primary'
										className='w-auto'
										icon='Replay'
										isLight
										//type='submit'
										onClick={handleClearSignature}>
										Effacer
									</Button>
									<Button
										color='success'
										type='submit'
										icon='FileDownloadDone'
										onClick={handleConfirm}
										isDisable={spinner}>
										{spinner && <Spinner isSmall inButton />}
										{spinner ? 'En cours' : 'Accepter et signer'}
									</Button>
								</CardFooterRight>
							</CardFooter>
						</CardTabItem>
						{/* <CardTabItem id='Charger' title='Charger'>
							<div className='row g-4 d-flex align-items-center'>
								{!attachementSignature?.length && (
									<FormGroup className='col-12' id='client' label={'Fichiers'}>
										<Input
											type='file'
											multiple
											name='attachementSignature'
											onChange={(e) => {
												const newAttachments = Array.from(e?.target?.files);
												setattachementSignature((prevAttachments) => [
													...prevAttachments,
													...newAttachments,
												]);
											}}
										/>
									</FormGroup>
								)}
								<div className='row'>
									{!!attachementSignature?.length &&
										attachementSignature?.map((file, index) => {
											return (
												<Attachements
													file={file}
													index={index}
													deleteImage={deleteImage}
												/>
											);
										})}
								</div>
							</div>
						</CardTabItem>
                         */}
						<CardTabItem id='auto' title='Automatique'>
							<SignatureInput name={devis?.clientId?.nom} sigCanvas={sigCanvas} />
							<CardFooter>
								<CardFooterRight>
									<Button
										color='success'
										type='submit'
										icon='FileDownloadDone'
										onClick={handleConfirmCanvas}
										isDisable={spinner}>
										{spinner && <Spinner isSmall inButton />}
										{spinner ? 'En cours' : 'Accepter et signer'}
									</Button>
								</CardFooterRight>
							</CardFooter>
						</CardTabItem>
					</Card>
				</ModalBody>
			</Modal>
			{!!paiement && (
				<CreatePaimentFromDevisPopup
					handleConfirm={(amount) => CreatePaiementData(amount)}
					handleCancel={handleCancel}
					setOpen={setPaiement}
					totalAmount={devis?.totalTTC}
				/>
			)}
			{!!obligation && (
				<StatusPopup icon='info' color='info' title={obligation} setOpen={setObligation} />
			)}
			{!!error && <ErrorPopup error={error} setOpen={setError} />}
			{!!success && (
				<StatusPopup
					icon='Verified'
					color='success'
					title={'Super!'}
					label={success}
					setOpen={() => {
						setSuccess(false);
						setOpenSignature(false)
						// setPaymentModalStatus(false);
					}}
				/>
			)}
		</>
	);
}
